import {
    SelectedOutcome,
    SelectionCountLimit,
} from '../types';

export function validateSelectionCountLimit(
    outcomes: Set<SelectedOutcome>,
    maxSelections: SelectionCountLimit[],
): boolean {
    const outcomesList = Array.from(outcomes);
    const marketGrouped = outcomesList.reduce((acc, outcome) => {
        if (!(outcome.marketId in acc)) {
            acc[outcome.marketId] = [];
        }
        acc[outcome.marketId].push(outcome);
        return acc;
    }, {} as Record<number, SelectedOutcome[]>);

    const outcomesGrouped = outcomesList.reduce((acc, outcome) => {
        if (!(outcome.outcomeId in acc)) {
            acc[outcome.outcomeId] = [];
        }
        acc[outcome.outcomeId].push(outcome);
        return acc;
    }, {} as Record<number, SelectedOutcome[]>);

    for (const selectionLimit of maxSelections) {
        const marketViolations = selectionLimit.markets.some((marketId) => {
            const marketOutcomes = marketGrouped[marketId] || [];
            return marketOutcomes.length > selectionLimit.limit;
        });

        if (marketViolations) {
            return false;
        }

        const outcomeViolations = selectionLimit.outcomes?.some((outcomeId) => {
            const outcomes = outcomesGrouped[outcomeId] || [];
            return outcomes.length > selectionLimit.limit;
        });

        if (outcomeViolations) {
            return false;
        }
    }

    return true;
}
